export default function (sortOrder) {
  return (value, nextValue) => {
    const parsedFirstValue = parseFloat(value);
    const parsedSecondValue = parseFloat(nextValue);

    if (parsedFirstValue === parsedSecondValue || (
      Number.isNaN(parsedFirstValue) && Number.isNaN(parsedSecondValue)
    )) {
      return 0;
    }

    if (Number.isNaN(parsedFirstValue)) return 1;

    if (Number.isNaN(parsedSecondValue)) return -1;

    if (parsedFirstValue < parsedSecondValue) {
      return sortOrder === 'asc' ? -1 : 1;
    }

    if (parsedFirstValue > parsedSecondValue) {
      return sortOrder === 'asc' ? 1 : -1;
    }

    return 0;
  };
}
